<template>
  <div v-if="currentUser">
    <b-form @keydown="form.errors.clear($event.target.name)" @submit.prevent="onSubmit">
      <template v-if="!readonly">
        <textarea
          v-model.trim="form.detail"
          class="job-note form-control"
          name="detail"
          placeholder="Type a user note here..."
          rows="3"
        ></textarea>

        <b-card-footer style="border-top: 0">
          <div class="row">
            <div class="col">
              <div class="d-flex">
                <button
                  v-if="!editingUpload"
                  :disabled="form.notReady() || (!form.detail && !form.file)"
                  class="btn btn-primary btn-sm mr-3"
                >
                  <font-awesome-icon v-if="form.busy" :icon="['fal', 'spinner']" spin />
                  <font-awesome-icon v-else :icon="['fal', 'plus-circle']" />
                  Add Text
                </button>

                <file-uploader
                  v-show="form.detail.length === 0"
                  :data="{ user_id: currentUser.id, action: form.action }"
                  :file-url="form.file"
                  post-action="user-notes"
                  @editing="editingUpload = true"
                  @notEditing="editingUpload = false"
                  @uploaded="fileUploaded"
                >
                  <font-awesome-icon :icon="['fal', 'cloud-upload']" />
                  Attach File
                </file-uploader>
              </div>
            </div>
            <div class="col text-right">
              <div class="btn-group-toggle btn-group btn-group-sm" data-toggle="buttons">
                <label
                  :class="{ active: form.action === '' }"
                  class="btn btn-outline-secondary cursor"
                  @click="form.action = ''"
                >
                  <input id="action-neutral" v-model="form.action" type="radio" value="" />
                  <font-awesome-icon :icon="['fal', 'file-invoice']" />
                  Note
                </label>
                <label
                  :class="{ active: form.action === 'performance_review' }"
                  class="btn btn-outline-secondary cursor"
                  @click="form.action = 'performance_review'"
                >
                  <input
                    id="action-performance-review"
                    v-model="form.action"
                    type="radio"
                    value="performance_review"
                  />
                  <font-awesome-icon :icon="['fal', 'clipboard-check']" />
                  Perf Review
                </label>
                <label
                  :class="{ active: form.action === 'proactive_feedback' }"
                  class="btn btn-outline-secondary cursor"
                  @click="form.action = 'proactive_feedback'"
                >
                  <input
                    id="action-performance-review"
                    v-model="form.action"
                    type="radio"
                    value="proactive_feedback"
                  />
                  <font-awesome-icon :icon="['fal', 'comment']" />
                  Proactive Feedback
                </label>
                <label
                  :class="{ active: form.action === 'praise' }"
                  class="btn btn-outline-secondary cursor"
                  @click="form.action = 'praise'"
                >
                  <input id="action-praise" v-model="form.action" type="radio" value="praise" />
                  <font-awesome-icon :icon="['fal', 'thumbs-up']" class="text-primary" />
                </label>
                <label
                  :class="{ active: form.action === 'complaint' }"
                  class="btn btn-outline-secondary cursor"
                  @click="form.action = 'complaint'"
                >
                  <input
                    id="action-complaint"
                    v-model="form.action"
                    type="radio"
                    value="complaint"
                  />
                  <font-awesome-icon :icon="['fal', 'thumbs-down']" class="text-danger" />
                </label>
              </div>
            </div>
          </div>
        </b-card-footer>
      </template>
      <template v-else>
        <header class="job-header row">
          <div class="main-heading">
            <b>Technician #{{ currentUser.name }}</b>
          </div>
        </header>
      </template>

      <div class="row no-print">
        <div class="col-8">
          <div class="mt-3">
            <b-button-group>
              <b-button
                :variant="filteringType === 'all' ? 'success' : ''"
                @click.prevent="filteringType = 'all'"
              >
                All
              </b-button>
              <b-button
                :variant="filteringType === 'notes' ? 'warning' : ''"
                @click.prevent="filteringType = 'notes'"
              >
                Notes
              </b-button>
              <b-button
                :variant="filteringType === 'files' ? 'dark' : ''"
                @click.prevent="filteringType = 'files'"
              >
                Files
              </b-button>
              <b-button
                :variant="filteringType === 'appraisal' ? 'danger' : ''"
                @click.prevent="filteringType = 'appraisal'"
              >
                Appraisals
              </b-button>
              <b-button
                :variant="filteringType === 'performance_review' ? 'danger' : ''"
                @click.prevent="filteringType = 'performance_review'"
              >
                Perf Review
              </b-button>
              <b-button
                :variant="filteringType === 'proactive_feedback' ? 'danger' : ''"
                @click.prevent="filteringType = 'proactive_feedback'"
              >
                Proactive Feedback
              </b-button>
              <b-button
                :variant="filteringType === 'log' ? 'info' : ''"
                @click.prevent="filteringType = 'log'"
              >
                Log
              </b-button>
            </b-button-group>
          </div>
          <div v-if="filteringType === 'log'" class="mt-1">
            <b-button-group size="sm">
              <b-button
                :variant="logsSubType === 'all' ? 'success' : ''"
                @click.prevent="logsSubType = 'all'"
              >
                All
              </b-button>
              <b-button
                :variant="logsSubType === 'profile' ? 'warning' : ''"
                @click.prevent="logsSubType = 'profile'"
              >
                User profile
              </b-button>
              <b-button
                :variant="logsSubType === 'unavailability' ? 'info' : ''"
                @click.prevent="logsSubType = 'unavailability'"
              >
                Unavailability
              </b-button>
              <b-button
                :variant="logsSubType === 'work-areas' ? 'danger' : ''"
                @click.prevent="logsSubType = 'work-areas'"
              >
                Work areas
              </b-button>
            </b-button-group>
          </div>
        </div>
        <div class="col-4 text-right pt-3">
          <button v-if="readonly" class="btn btn-primary no-print" @click.prevent="print">
            <font-awesome-icon :icon="['fal', 'file-pdf']" />
            Print
          </button>

          <b-button v-else variant="primary" @click.prevent="exportLog"> Export Log</b-button>
        </div>
      </div>

      <ul :style="readonly ? '' : 'max-height: 552px'" class="list-group overflow-y-auto mt-3">
        <!-- eslint-disable -->
        <li
          v-for="activity in filteredActivities"
          :key="activity.id + activity.action"
          class="list-group-item activity"
        >
          <div class="row no-gutters">
            <div class="col-auto">
              <div class="highlight text-center">
                <font-awesome-icon
                  :class="getOperationClass(activity)"
                  :icon="getOperationIcon(activity)"
                />
              </div>
            </div>
            <div class="col">
              <template v-if="activity.tabType === 'log'">
                {{ activity.action }}:

                <template
                  v-if="
                    activity.action === 'Unavailabilities created' ||
                    activity.action === 'Unavailabilities deleted'
                  "
                >
                  <unavailability-object
                    v-for="(timeslot, index) in activity.detail.unavailabilities"
                    :key="activity.id + index"
                    :timeslot="timeslot"
                    :tooltip="timeslot.reason"
                  />
                </template>
                <template v-else-if="activity.action === 'Unavailabilities updated'">
                  <b>From: </b>
                  <unavailability-object
                    :timeslot="activity.detail.before"
                    :tooltip="activity.detail.before.reason"
                  />
                  <b>To: </b>
                  <unavailability-object
                    :timeslot="activity.detail.diff"
                    :tooltip="activity.detail.diff.reason"
                  />
                </template>
                <template v-else>
                  <generic-object
                    v-for="(content, key) in activity.detail.diff"
                    :key="activity.id + key"
                    :copy-to-clipboard="true"
                    :tooltip="changeTooltip(content, key, activity.detail.before, activity.action)"
                  >
                    {{ key.replace(/_/g, " ") | capitalize }}
                  </generic-object>
                </template>
              </template>
              <template v-else>
                <div class="whitespace-preline">{{ activity.detail }}</div>
              </template>

              <div v-if="$lodash.has(activity, 'media[0].url')" class="w-100">
                <div
                  v-if="
                    activity.media[0].mime_type === 'image/jpeg' ||
                    activity.media[0].mime_type === 'image/jpg' ||
                    activity.media[0].mime_type === 'image/gif' ||
                    activity.media[0].mime_type === 'image/png'
                  "
                >
                  <img
                    v-img="{
                      src: activity.media[0].url,
                      sourceButton: true,
                      group: 'activities',
                    }"
                    :src="activity.media[0].url"
                    alt=""
                    width="100"
                  />
                </div>
                <div v-else-if="activity.media[0].mime_type === 'application/pdf'">
                  View attached
                  <pdf-object :href="activity.media[0].url" />
                </div>
                <div v-else>
                  View attached <a :href="activity.media[0].url" target="_blank">file</a>
                </div>
              </div>

              <div class="text-muted">
                {{ formatLocalDate(activity.created_at) }}
                by
                {{ activity.updated_by ? activity.updated_by.name : "Anonymous" }}
              </div>
            </div>
          </div>
        </li>
        <li
          v-if="filteringType === 'all' && activities.length === 0"
          class="list-group-item activity text-center"
        >
          No activities yet
        </li>
      </ul>

      <div class="mt-3">
        <button
          v-if="!readonly"
          :disabled="!lastPage || this.page >= lastPage || form.busy || loadingMore"
          class="btn btn-primary"
          @click.prevent="loadMore"
        >
          <font-awesome-icon v-if="form.busy || loadingMore" :icon="['fal', 'spinner']" spin />
          <font-awesome-icon v-else :icon="['fal', 'caret-down']" />
          Load more
        </button>
      </div>
    </b-form>
  </div>
</template>

<script type="text/babel">
import format from "../../../mixins/format";
import EventBus from "../../../imports/event-bus";
import FileUploader from "../../../components/common/FileUploader.vue";

const initialState = {
  id: "",
  user_id: "",
  action: "",
  detail: "",
  file: "",
};

export default {
  components: {
    FileUploader,
  },
  mixins: [format],

  props: {
    currentUser: {
      required: true,
    },

    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      initialised: false,
      filteringType: this.readonly ? "log" : "notes",
      logsSubType: "all",
      activities: [],

      perPage: 50,
      page: 0,
      lastPage: null,
      loadingMore: false,

      editingUpload: false,

      form: new window.AppForm(initialState),
    };
  },

  computed: {
    filteredActivities() {
      return this.activities.filter((activity) => {
        return (
          this.filteringType === "all" ||
          (this.filteringType === "notes" &&
            activity.tabType === "note" &&
            activity.media.length === 0 &&
            activity.action === null) ||
          (this.filteringType === "files" &&
            activity.tabType === "note" &&
            activity.media.length > 0 &&
            activity.action === null) ||
          (this.filteringType === "appraisal" &&
            activity.tabType === "note" &&
            activity.type === "appraisal") ||
          (this.filteringType === "performance_review" &&
            activity.tabType === "note" &&
            activity.type === "performance_review") ||
          (this.filteringType === "proactive_feedback" &&
            activity.tabType === "note" &&
            activity.type === "proactive_feedback") ||
          (this.filteringType === "log" &&
            activity.tabType === "log" &&
            this.logsSubType === "all") ||
          (this.filteringType === "log" &&
            activity.tabType === "log" &&
            this.logsSubType === "profile" &&
            activity.action &&
            activity.action.startsWith("User profile")) ||
          (this.filteringType === "log" &&
            activity.tabType === "log" &&
            this.logsSubType === "unavailability" &&
            activity.action &&
            activity.action.startsWith("Unavailabilities")) ||
          (this.filteringType === "log" &&
            activity.tabType === "log" &&
            this.logsSubType === "work-areas" &&
            activity.action &&
            activity.action.startsWith("Work areas"))
        );
      });
    },
  },

  mounted() {
    this.init();

    EventBus.$on("user-updated", () => {
      this.init();
    });
  },

  methods: {
    init() {
      this.form.reset();
      this.form.user_id = this.currentUser.id;

      this.activities = [];
      this.page = 0;
      this.lastPage = null;
      this.loadingMore = false;

      return this.loadMore();
    },

    /* eslint-disable no-param-reassign */
    loadMore() {
      if (this.page < this.lastPage || this.lastPage === null) {
        const page = this.page + 1;
        this.loadingMore = true;

        this.form.startProcessing();

        const limit = this.readonly ? 99999999 : this.perPage;

        // noinspection JSUnresolvedFunction
        this.$http
          .get(`/users/${this.currentUser.id}/activities?page=${page}&limit=${limit}`)
          .then((response) => {
            // Unpack the JSON in detail property
            if (response.body.data && response.body.data.length > 0) {
              this.page = response.body.current_page;
              this.lastPage = response.body.last_page;

              try {
                response.body.data.forEach((activity, index) => {
                  if (
                    activity.action &&
                    activity.type !== "appraisal" &&
                    activity.type !== "performance_review" &&
                    activity.type !== "proactive_feedback" &&
                    activity.detail
                  ) {
                    response.body.data[index].detail = JSON.parse(activity.detail);
                    response.body.data[index].tabType = "log";
                  } else {
                    response.body.data[index].tabType = "note";
                  }
                });
              } catch (error) {
                window.toastr.error("There seems to be some problem with activity data.", "Oops");
              }
            }

            this.activities = this.activities.concat(response.body.data);

            this.page = response.body.current_page;
            this.lastPage = response.body.last_page;

            this.initialised = true;
            this.loadingMore = false;
            this.form.finishProcessing();
          })
          .catch(() => {
            this.initialised = true;
            this.loadingMore = false;
            this.form.finishProcessing();
          });
      }
    },

    onSubmit() {
      if (!this.form.detail) {
        return;
      }

      this.form.post("/user-notes").then(() => {
        this.$nextTick(() => this.init());

        window.toastr.success("Note added!", "Success");
      });
    },

    getOperationClass(activity) {
      switch (activity.action) {
        case "User profile created":
        case "Unavailabilities created":
        case "praise":
          return "successful";

        case "Work areas updated":
        case "User profile updated":
        case "Unavailabilities updated":
          return "update";

        case "Unavailabilities deleted":
        case "complaint":
          return "destroy";

        default:
          return "";
      }
    },

    getOperationIcon(activity) {
      switch (activity.action) {
        case "User profile created":
        case "User profile updated":
          return ["fal", "user-edit"];

        case "Work areas updated":
          return ["fal", "map"];

        case "Unavailabilities created":
          return ["fal", "calendar-plus"];

        case "Unavailabilities updated":
          return ["fal", "calendar-edit"];

        case "Unavailabilities deleted":
          return ["fal", "calendar-times"];

        case null:
          if (activity.media.length > 0) {
            if (
              activity.media[0].mime_type === "image/jpeg" ||
              activity.media[0].mime_type === "image/jpg" ||
              activity.media[0].mime_type === "image/gif" ||
              activity.media[0].mime_type === "image/png"
            ) {
              if (this.$lodash.get(activity.media[0], "file_name") === "signature.jpg") {
                return ["fal", "signature"];
              }

              return ["fal", "image"];
            }

            return ["fal", "paperclip"];
          }
          return ["fal", "user-edit"];

        case "praise":
          return ["fal", "thumbs-up"];

        case "complaint":
          return ["fal", "thumbs-down"];

        default:
          return ["fal", "user-edit"];
      }
    },

    fileUploaded() {
      window.toastr.success("Attachment added!", "Success");

      this.init();
    },

    isArray(obj) {
      return !!obj && obj.constructor === Array;
    },

    changeTooltip(content, key, before, action) {
      let changeFrom;
      let changeTo;

      if (this.isArray(content)) {
        changeFrom = this.$lodash.get(before, key, []).join(", ");
        changeTo = content.join(", ");
      } else {
        changeFrom = this.$lodash.get(before, key, "");
        changeTo = content;
      }

      if (action === "User profile created") {
        return String(changeTo);
      }

      return `Changed from: '${changeFrom}' to: '${changeTo}'`;
    },

    print() {
      window.print();
    },

    exportLog() {
      window.open(`/users/${this.currentUser.id}/logs`);
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.activity {
  padding: 10px 8px 6px 0;

  font-size: 13px;
  line-height: 24px;
}

.highlight {
  width: 50px;

  i {
    font-size: 25px;
    color: #919191;
  }

  .successful {
    color: #79cc9b;
  }

  .update {
    color: #f7c16b;
  }

  .destroy {
    color: #d9534f;
  }
}

.badge {
  margin-right: 4px;
}

.btn-outline-secondary {
  color: #6d7680;
}
</style>
